// Centralized login redirect logic
export function redirectAfterLogin() {
  // Always redirect to dashboard
  if (typeof window !== 'undefined') {
    window.location.replace('/dashboard');
  }
}
